if (location.protocol === 'file:') {
  const ajaxOpen = XMLHttpRequest.prototype.open

  XMLHttpRequest.prototype.open = function (method, url, async) {
    ajaxOpen.apply(this, arguments)

    if (/^static\/gltf\//.test(url)) {
      // eslint-disable-next-line no-new
      new Promise(resolve => {
        resolve()
      }).then(() => {
        let onReadyStateChange = this.onreadystatechange

        this.onreadystatechange = () => {
          Object.defineProperty(this, 'readyState', {
            value: 4
          })

          Object.defineProperty(this, 'status', {
            value: 200
          })

          this.onreadystatechange = onReadyStateChange
          onReadyStateChange = null
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/gltfAjax.js